import {getLevantaProductsService, getLevantProductsService, getProductsService} from "../services/products";

const GetLevantaProductsData = async (setLoading, setError, setErrorMessage, setData, params, categoryId, setHasMore, dispatch) => {
    setLoading(true);
    setErrorMessage('');

    try {
        const results = await getLevantaProductsService(new URLSearchParams(params).toString());
        if(!results['data']) {
            setError(true);
            setErrorMessage(results['error'] || 'Sorry! This category doesn\'t have any products!')
        } else if(results['data'] && results['data']['products'] && results['data']['products'].length === 0) {
            setHasMore(false);
            setLoading(false);
            setData([]);
            return params;
        } else {
            setError(false);
            setErrorMessage('');
            setData(results['data']['products']);
        }
        setLoading(false);
        if(setHasMore) setHasMore(true);

        return params;
    } catch (error) {
        setLoading(false);
        setError(true);
        setErrorMessage('');
        console.error('Error!', error);
    }
}

export default GetLevantaProductsData;
